import { render, staticRenderFns } from "./TradingTradesFilters.vue?vue&type=template&id=18162cae&"
import script from "./TradingTradesFilters.vue?vue&type=script&lang=js&"
export * from "./TradingTradesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports